// Login page scripts

// Redirect if customer is already logged in
function redirectLoggedInCustomer() {
  try { 
    localStorage.removeItem('login_email'); 
  } catch(e) {}
  window.location = '/pages/account-loyalty';
}

// Observe and style AAI button
function observeAAIButton() {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          const link = node.querySelector ? node.querySelector('#AAI-buttontext a') : null;
          const directLink = node.id === 'AAI-buttontext' ? node.querySelector('a') : null;
          
          if (link || directLink) {
            const targetLink = link || directLink;
            targetLink.classList.add('btn', 'btn--primary', 'btn--solid', 'btn--large');
            observer.disconnect(); 
          }
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Handle email input and localStorage
function handleEmailStorage() {
  var emailInput = document.getElementById('customer_email');
  if(!emailInput) return;

  try {
    var stored = localStorage.getItem('login_email');
    if(emailInput.value === '' && stored) {
      emailInput.value = stored;
    }
  } catch(e) {}

  emailInput.addEventListener('input', function() {
    try {
      if (emailInput.value && emailInput.value.indexOf('@') !== -1) {
        localStorage.setItem('login_email', emailInput.value.trim());
      } else if(!emailInput.value) {
        localStorage.removeItem('login_email');
      }
    } catch(e) {}
  });

  var form = emailInput.form;
  if(form) {
    form.addEventListener('submit', function() {
      try { 
        localStorage.setItem('login_email', emailInput.value.trim()); 
      } catch(e) {}
    });
  }
}

// Initialize all functions when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    observeAAIButton();
    handleEmailStorage();
  });
} else {
  observeAAIButton();
  handleEmailStorage();
}
